import { render, staticRenderFns } from "./GlobalMarketing.vue?vue&type=template&id=41e28ddf&scoped=true&"
import script from "./GlobalMarketing.vue?vue&type=script&lang=js&"
export * from "./GlobalMarketing.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMarketing.vue?vue&type=style&index=0&id=41e28ddf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e28ddf",
  null
  
)

export default component.exports